module.exports = __webpack_public_path__ + "img/myposition_gk.a5e174a1.svg";